export default {
    namespaced: true,
    state: {
        quant: 1,
        mainPrice: null,
        annexation: 0,
        crossflag: false,
        interface: null,
        fetchInfo: null,
        is_quarter: false,
        accounts: [], //多账号续费的帐号
        rennewlist:{status:true,msg:""},//存储续购勾选状态
    },
    mutations: {
        setQuant(state, payload) {
            state.quant = payload
        },
        setPrice (state, payload) {
            state.annexation = payload
        },
        setMainPrice (state,payload) {
            state.mainPrice = payload
        },
        setCrossFlag (state,payload) {
            state.crossflag = payload
        },
        setInfo (state,payload) {
            state.fetchInfo = payload
        },
        setAccounts(state,val) {
            state.accounts = val
        },
        setInterface (state, payload) {
            state.interface = payload
        },
        setQuarterMode (state, val) {
            state.is_quarter = val
        },
        setCanRenNew(state, val) {
            state.rennewlist = {...val}
        }
    },
    getters: {
        isDzh (state) {
            return state.accounts.length > 0
        }
    },
    actions: {},
    modules: {

    }
}